export default __webpack_public_path__ + "static/media/gallery-sirius_01.15a96a4e.jpg";